import { IconButton, Stack, TableCell, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { memo } from 'react';
import { FieldArrayWithId, UseFieldArrayRemove, UseFormReturn } from 'react-hook-form';

import { CloseIcon } from '@zeta-core/assets';
import CommonTableLayout from './common-table-layout';
import { renderComponent } from './render-component';
import { IGeneralFieldType } from './render-fields';

interface IIncomeTable {
  fieldArray: FieldArrayWithId<{ id: string; currency?: string }, never, 'id'>[];
  currentTab: string;
  tableDetails: any[];
  onRemove: UseFieldArrayRemove;
  methods?: UseFormReturn<any>;
  isClient?: boolean;
  isReadOnly?: boolean;
}

const SimpleFieldsTable = ({ fieldArray, currentTab, onRemove, tableDetails, methods, isClient, isReadOnly }: IIncomeTable) => {
  return (
    <CommonTableLayout tableHead={tableDetails}>
      <>
        {fieldArray?.map((fArray, fieldArrayIndex) => {
          if (methods) {
            const DOB = methods.watch(`${currentTab}.${fieldArrayIndex}.dateOfBirth`);
            if (dayjs(DOB).isValid()) methods.setValue(`${currentTab}.${fieldArrayIndex}.age`, dayjs().diff(dayjs(DOB), 'year').toString());
          }

          return (
            fArray.show && (
              <TableRow key={`${fArray.id || fArray.name}`}>
                {tableDetails.slice(0, -1).map(
                  (tableContent: IGeneralFieldType) =>
                    tableContent.show && (
                      <TableCell key={tableContent.name} id={tableContent.name}>
                        {renderComponent(
                          tableContent,
                          `${currentTab}.${fieldArrayIndex}.${tableContent.name}`,
                          tableContent.sxProp,
                          tableContent?.disabled,
                          tableContent?.getOptionLabel,
                          fArray,
                          isClient || isReadOnly
                        )}
                      </TableCell>
                    )
                )}

                <TableCell>
                  <Stack display="flex" justifyContent="center" alignItems="center" marginTop={0.5}>
                    <IconButton
                      disabled={isClient || isReadOnly}
                      id={`removeIcon-${fieldArrayIndex}`}
                      name="removeIcon"
                      onClick={() => {
                        onRemove(fieldArrayIndex);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            )
          );
        })}
      </>
    </CommonTableLayout>
  );
};

export default memo(SimpleFieldsTable);
